<template>
  <v-flex v-bind="vflexProps">
    <input-select
      v-model="getValue"
      :items="status"
      item-value="value"
      item-text="text"
      clearable
      :label="$t('app.customers.list.searchSituations')"
      hide-details
    />
  </v-flex>
</template>

<script>
import InputSelect from 'Support/components/inputs/InputSelect.vue';

export default {
  name: 'StatusFilter',
  components: {
    InputSelect,
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    status: {
      type: Array,
      required: true,
    },
    vflexProps: {
      type: Object,
      default() {
        return {
          xs2: true,
        };
      },
    },
  },
  data: () => ({
    filter: {},
  }),
  computed: {
    getValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
